<div class="playlist-container">

  <div class="playerlist-header-container-row">
    <mwo-scheduler [displayFullPage]="false"></mwo-scheduler>
  </div>

  <div class="playlist-main-content">

    <mwo-breadcrumb (click)="back()" title="{{ 'library.title' | translate }}"></mwo-breadcrumb>

    <div class="playlist-col-container">
      <div class="playlist-header-container">
        <div class="playlist-header">
          <div class="header-right-info">
            <div class="title">
              <span class="playlist-title">{{ 'history.title' | translate }}</span>
            </div>
            <div class="playlist-details">
              <div class="playlist-info">
                <mwo-list-counter [count]="totalLength" [message]="'playlistsFamilies.label.tracks'" class="media-data"
                  id="playlist-counter"></mwo-list-counter>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="title-tracks">
        <div class="box-music">
          <div class="box-music-content">
            <div *ngFor="let item of (historyList$ | async)">
              <mwo-track [item]="item" [mode]="'history'"></mwo-track>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>